import React, { PropsWithChildren } from 'react'
import { Cookies } from '../Cookies'
import { MenuBar } from '../MenuBar'
import MetaTags, { MetaTagsProps } from '../MetaTags'
import { Content } from '../../components/Content'
import { Footer } from '../Footer'
import { MenuBarProps } from '../MenuBar/MenuBar'

export type MarketingPageProps = PropsWithChildren<{}> & MetaTagsProps & MenuBarProps

const MarketingPage = ({ children, ...props }: MarketingPageProps) => {
  return (
    <>
      <MetaTags {...props} />
      <Cookies />
      <MenuBar currentPage={props.currentPage} menuItems={props.menuItems} />
      <Content>{children}</Content>
      <Footer />
    </>
  )
}

export default MarketingPage
